module.exports = __webpack_public_path__ + "v4assets/library-screenshot-dark.c4db2334d056a08f82816c178ef676d8.png";